export const rulesActions = {
    RULES_SHOW: 'RULES_SHOW',
    RULES_HIDE: 'RULES_HIDE'
};
